module.exports = __webpack_public_path__ + "img/root.1953abd4.png";